import { DefaultTooltip, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui"

import { SPACING_OPTIONS } from "./helpers"

const Section = ({ children, type, onTypeChange }) => <>
  <span className='absolute top-0 px-1 py-1 left-0 flex gap-0.5 items-start justify-between twy-text-base w-full'>
    <div className='px-1'>
      {children}
    </div>
    <ToggleOptionGroup type='single' value={type} onValueChange={value => value && onTypeChange(value)} className='opacity-50 hover:opacity-100'>
      {SPACING_OPTIONS.map(({ tooltip, value, icon }) => <>
        <ToggleOptionGroupItem value={value} variant='accent' className='px-1 py-px'>
          <DefaultTooltip content={tooltip}>
            {icon}
          </DefaultTooltip>
        </ToggleOptionGroupItem>
      </>)}
    </ToggleOptionGroup>
  </span>
</>

export default Section
